import React from "react";

import { QRFRameProps } from "../types";

import { getPreviewFrameFontSize } from "@/utils/qrEditorHelper";

import "../styles.scss";

export const menuFrame = (
  props: Omit<QRFRameProps, "frameType">
): React.SVGProps<SVGSVGElement> => {
  const { text, textColor, children, frameColor, frameBackgroundColor, urlQr } = props;

  const fontSize = getPreviewFrameFontSize(text?.length);

  return (
    <svg
      width="96"
      height="128"
      viewBox="0 0 96 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.5"
        y="0.5"
        width="95"
        height="127"
        rx="7.5"
        fill="white"
      />
      <rect
        x="0.5"
        y="0.5"
        width="95"
        height="127"
        rx="7.5"
        stroke="#BFBFBF"
      />
      <path
        d="M11.0035 33.0035C11.0016 32.4498 11.4498 32 12.0035 32H57.9993C58.5519 32 58.9997 32.4481 58.9993 33.0007L58.9559 95.0007C58.9555 95.5527 58.5079 96 57.9559 96H12.2185C11.6675 96 11.2204 95.5544 11.2185 95.0035L11.0035 33.0035Z"
        fill={frameBackgroundColor}
      />
      <path
        d="M84.0367 84.6271C84.0367 85.3661 83.4355 85.9672 82.6966 85.9672H59.493V74.5857H76.5178C76.8076 74.5857 77.0424 74.3506 77.0424 74.0611C77.0424 73.7713 76.8076 73.5362 76.5178 73.5362H59.493V65.0797H76.5178C76.8076 65.0797 77.0424 64.8451 77.0424 64.5552C77.0424 64.2654 76.8076 64.0306 76.5178 64.0306H59.493V55.5738H76.5178C76.8076 55.5738 77.0424 55.339 77.0424 55.0492C77.0424 54.7594 76.8076 54.5245 76.5178 54.5245H59.493V46.068H76.5178C76.8076 46.068 77.0424 45.8329 77.0424 45.5433C77.0424 45.2535 76.8076 45.0184 76.5178 45.0184H59.493V36.5619H76.5178C76.8076 36.5619 77.0424 36.3271 77.0424 36.0373C77.0424 35.7474 76.8076 35.5129 76.5178 35.5129H59.493V31.2845C59.493 31.2726 59.4905 31.2614 59.4897 31.2498C59.4882 31.2287 59.4872 31.2077 59.4834 31.1869C59.4801 31.1705 59.4748 31.1548 59.47 31.1388C59.4654 31.1223 59.4613 31.1059 59.455 31.0902C59.4484 31.074 59.4401 31.0588 59.432 31.0436C59.4244 31.0286 59.4173 31.0139 59.4084 31C59.3993 30.9858 59.3886 30.9734 59.3783 30.9605C59.3676 30.9468 59.3575 30.9328 59.3453 30.9204C59.3334 30.908 59.32 30.8976 59.3071 30.8865C59.2944 30.8758 59.2822 30.8644 59.2683 30.8546C59.2513 30.8427 59.2326 30.833 59.2138 30.8234C59.2034 30.8178 59.1946 30.8107 59.1837 30.8059L39.4761 21.9375H82.6966C83.4355 21.9375 84.0367 22.5387 84.0367 23.2776V84.6271ZM58.4437 94.4987C58.4437 95.2377 57.8428 95.8389 57.1038 95.8389H13.3035C12.5645 95.8389 11.9634 95.2377 11.9634 94.4987V33.149C11.9634 32.41 12.5645 31.8089 13.3035 31.8089H58.4437V94.4987ZM37.5561 22.2243L56.5239 30.7596H37.5561V22.2243ZM82.6966 20.8882H37.0317C37.0196 20.8882 37.0084 20.891 36.9962 20.8917C36.9757 20.8932 36.955 20.894 36.9344 20.8981C36.9175 20.9011 36.9018 20.9067 36.8855 20.9115C36.8693 20.916 36.8531 20.9201 36.8377 20.9262C36.8212 20.9328 36.806 20.9414 36.7903 20.9495C36.7756 20.9571 36.7612 20.9639 36.7475 20.9728C36.7333 20.9819 36.7209 20.9928 36.7075 21.0032C36.694 21.0138 36.6803 21.024 36.6677 21.0359C36.6555 21.0478 36.6451 21.0612 36.634 21.0741C36.6231 21.0871 36.6117 21.099 36.6021 21.1129C36.5899 21.1301 36.5805 21.1486 36.5707 21.1674C36.5651 21.1777 36.558 21.1869 36.5532 21.1975L36.5517 21.2026C36.543 21.2216 36.5375 21.2421 36.5314 21.2626C36.5273 21.276 36.5218 21.2892 36.519 21.3029C36.5162 21.3161 36.5157 21.3303 36.5139 21.3442C36.5111 21.3652 36.5078 21.3865 36.5076 21.4078L36.5071 21.4128V30.7596H13.3035C11.9859 30.7596 10.9141 31.8314 10.9141 33.149V94.4987C10.9141 95.8163 11.9859 96.8882 13.3035 96.8882H57.1038C58.4212 96.8882 59.493 95.8163 59.493 94.4987V87.0165H82.6966C84.0142 87.0165 85.086 85.9447 85.086 84.6271V23.2776C85.086 21.96 84.0142 20.8882 82.6966 20.8882Z"
        fill={frameColor}
      />

      <foreignObject
        width="46%"
        height="46px"
        style={{ borderRadius: "3px" }}
        x="13"
        y="43">
        <div
          id="#qrCode"
          style={{
            border: `1px solid ${frameBackgroundColor || "white"}`,
            width: "100%",
            height: "100%",
            boxSizing: "border-box",

            backgroundColor: `${frameBackgroundColor}`,
          }}>
          {urlQr ? (
            <img
              src={urlQr}
              width="100%"
              height="auto"
            />
          ) : (
            children
          )}
        </div>
      </foreignObject>
      <foreignObject
        width="100%"
        height="18px"
        y="102">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          style={{ width: "100%", height: "100%", maxWidth: "100%" }}>
          <text
            x="50%"
            y="11"
            fill={textColor}
            dominantBaseline="middle"
            textAnchor="middle"
            fontFamily="sans-serif"
            fontWeight="bold"
            style={{ fontSize }}>
            {text}
          </text>
        </svg>
      </foreignObject>
    </svg>
  );
};
